export const WORKER_ROLES = [
  {
    value: 'coordenador_municipal',
    label: 'Coordenador municipal',
    color: 'bg-indigo-100 text-indigo-700',
    dot: 'bg-indigo-500',
  },
  {
    value: 'lideranca_bairro',
    label: 'Liderança de bairro',
    color: 'bg-blue-100 text-blue-700',
    dot: 'bg-blue-500',
  },
  {
    value: 'cabo',
    label: 'Cabo eleitoral',
    color: 'bg-amber-100 text-amber-700',
    dot: 'bg-amber-500',
  },
  {
    value: 'apoiador',
    label: 'Apoiador',
    color: 'bg-emerald-100 text-emerald-700',
    dot: 'bg-emerald-500',
  },
  {
    value: 'voluntario',
    label: 'Voluntário',
    color: 'bg-teal-100 text-teal-700',
    dot: 'bg-teal-500',
  },
];

export const workerRoleMeta = v => WORKER_ROLES.find(r => r.value === v) || {};
